import React, { useMemo } from "react"
import { IoIosArrowRoundBack, IoMdArrowRoundBack } from "react-icons/io"
import { useHistory, useParams } from "react-router-dom"
import "react-h5-audio-player/lib/styles.css"
import { useState } from "react"
import { useEffect } from "react"
import api, { BASE_URL, fetcher } from "../../utils/api"
import Spinner from "../../components/Spinner"
import { BsPerson, BsChevronLeft, BsChevronRight, BsSearch, BsCalendar } from "react-icons/bs"
import "react-responsive-modal/styles.css"
import { Modal } from "react-responsive-modal"
import { Form } from "react-bootstrap"
import useSWR from "swr"
import { IoArrowBack, IoArrowForward } from "react-icons/io5"
import { ErrorNotification, SuccessNotification } from "../../utils"
import {
  formatHarvestEstimatedValue,
  formatHarvestPriceDisplay,
  formatHarvestQuantityDisplay,
  getWeightFieldLabel,
} from "../../utils/harvestRequest"

const timeOptions = ["AM", "PM"]

const HarvestDetailView = (props) => {
  const history = useHistory()
  const { id: urlId } = useParams()
  const routeState = props?.location?.state?.state
  const request = routeState || { id: urlId, request_id: urlId }
  const requestId = request?.id || request?.request_id || urlId
  const [selectedFarmers, setSelectedFarmers] = useState([])
  const [appointmentMode, setAppointmentMode] = useState(null)
  const [selectedFarmer, setSelectedFarmer] = useState(null)
  const [selectedTime, setSelectedTime] = useState(null)
  const [selectedDate, setSelectedDate] = useState(null)
  const [selectedOption, setSelectedOption] = useState(null)
  const [appointmentDescription, setAppointmentDescription] = useState("Pick up for produce")
  const [submitAppointment, setSubmitAppointment] = useState(false)
  const { data: smsSenderIdsData, isLoading: loadingSenderIds, mutate: mutateSenderIds } = useSWR(`sms-sender-ids/`, fetcher)
  const smsSenderIds = Array.isArray(smsSenderIdsData) ? smsSenderIdsData : []
  const approvedSenderIds = smsSenderIds.filter(id => id.status === 'approved')
  // if not approved we use this TESTSENDRID
  const defaultSenderId = approvedSenderIds[0]?.effective_sender_id || "Solidaridad"

  const { data, isLoading, mutate } = useSWR(
    requestId ? `harvest-requests/${requestId}` : null,
    fetcher
  )

  const harvestDetail = useMemo(() => {
    return {
      ...data,
      responses: data?.responses?.length > 0 ?
        data?.responses?.map(response => ({
          ...response,
          user_data: {
            ...response?.responder_farmer || {},
            ...response?.responder_user || {}
          }
        })) : []
    }
  }, [data])

  const handleTimeChange = (e) => {
    setSelectedTime(e.target.value)
  }

  const bookableResponses = useMemo(
    () => harvestDetail?.responses?.filter(
      (response) => response?.response_type?.toLowerCase() === "accept"
    ) || [],
    [harvestDetail?.responses]
  )

  const getFarmersForBooking = () => {
    if (appointmentMode === "bulk") {
      return bookableResponses
        .filter((response) => selectedFarmers.includes(response.id))
        .map((response) => response.user_data)
        .filter((farmer) => farmer?.id)
    }
    return selectedFarmer?.id ? [selectedFarmer] : []
  }

  const resetAppointmentForm = () => {
    setAppointmentMode(null)
    setSelectedFarmer(null)
    setSelectedDate(null)
    setSelectedTime(null)
    setAppointmentDescription("Pick up for produce")
    setSelectedFarmers([])
  }

  const handleSubmitAppointment = async () => {
    const farmersToBook = getFarmersForBooking()

    if (!farmersToBook.length) {
      ErrorNotification("Please select at least one farmer to book an appointment")
      return
    }
    if (!selectedDate || !selectedTime) {
      ErrorNotification("Please select a date and time for the appointment")
      return
    }

    setSubmitAppointment(true)

    try {
      const results = await Promise.allSettled(
        farmersToBook.map((farmer) =>
          api.post(`appointments/`, {
            farmer: farmer.id,
            date: selectedDate,
            time: selectedTime,
            message: appointmentDescription,
            sms_nickname: defaultSenderId,
            sms_sender_id: defaultSenderId,
          })
        )
      )

      const succeeded = results.filter(
        (result) => result.status === "fulfilled" && result.value?.status === 201
      ).length
      const failed = results.length - succeeded

      if (succeeded > 0) {
        SuccessNotification(
          succeeded === 1
            ? "Appointment booked successfully"
            : `${succeeded} appointments booked successfully`
        )
        resetAppointmentForm()
        mutate()
      }

      if (failed > 0) {
        ErrorNotification(
          failed === 1
            ? "1 appointment failed to book"
            : `${failed} appointments failed to book`
        )
      }
    } catch (error) {
      if (error?.response?.data) {
        ErrorNotification(
          typeof error.response.data === "string"
            ? error.response.data
            : JSON.stringify(error.response.data)
        )
      } else {
        ErrorNotification("Failed to book appointment")
      }
    } finally {
      setSubmitAppointment(false)
    }
  }

  // Dummy data for responses
  // const dummyResponses = [
  //   {
  //     id: 1,
  //     farmer: {
  //       name: "Olivia Rhye",
  //       avatar: null
  //     },
  //     availableWeight: 2000,
  //     quantity: 40,
  //     ussdResponse: "Responded",
  //     dateReceived: "2025-04-01",
  //     supplyResponse: "Accept"
  //   },
  //   {
  //     id: 2,
  //     farmer: {
  //       name: "Phoenix Baker",
  //       avatar: null
  //     },
  //     availableWeight: 2000,
  //     quantity: 40,
  //     ussdResponse: "No Response",
  //     dateReceived: "2025-04-01",
  //     supplyResponse: "Rejected"
  //   },
  //   {
  //     id: 3,
  //     farmer: {
  //       name: "Lana Steiner",
  //       avatar: null
  //     },
  //     availableWeight: 2000,
  //     quantity: 40,
  //     ussdResponse: "Responded",
  //     dateReceived: "2025-04-01",
  //     supplyResponse: "Accept"
  //   },
  //   {
  //     id: 4,
  //     farmer: {
  //       name: "Demi Wilkinson",
  //       avatar: null
  //     },
  //     availableWeight: 2000,
  //     quantity: 40,
  //     ussdResponse: "Responded",
  //     dateReceived: "2025-04-01",
  //     supplyResponse: "Accept"
  //   },
  //   {
  //     id: 5,
  //     farmer: {
  //       name: "Candice Wu",
  //       avatar: null
  //     },
  //     availableWeight: 2000,
  //     quantity: 40,
  //     ussdResponse: "Declined",
  //     dateReceived: "2025-04-01",
  //     supplyResponse: "Rejected"
  //   }
  // ]

  // const dummyResponses = []

  const formatDate = (dateString) => {
    if (!dateString) return 'N/A'
    const date = new Date(dateString)
    return date.toLocaleDateString('en-GB', {
      weekday: 'short',
      day: 'numeric',
      month: 'short',
      year: 'numeric'
    })
  }

  const getUssdResponseColor = (status) => {
    switch (status?.toLowerCase()) {
      case 'accept':
        return 'bg-green-100 text-green-700'
      case 'reject':
      case 'rejected':
        return 'bg-red-100 text-red-700'
      case 'responded':
        return 'bg-green-100 text-green-700'
      case 'no response':
        return 'bg-yellow-100 text-yellow-700'
      case 'declined':
        return 'bg-red-100 text-red-700'
      default:
        return 'bg-gray-100 text-gray-700'
    }
  }

  const getInitials = (name) => {
    return name.split(' ').map(n => n[0]).join('').toUpperCase()
  }

  const handleSelectFarmer = (farmerId) => {
    setSelectedFarmers(prev =>
      prev.includes(farmerId)
        ? prev.filter(id => id !== farmerId)
        : [...prev, farmerId]
    )
  }

  const handleSelectAll = () => {
    if (selectedFarmers.length === bookableResponses.length) {
      setSelectedFarmers([])
    } else {
      setSelectedFarmers(bookableResponses.map((response) => response.id))
    }
  }

  const openBulkAppointment = () => {
    if (!selectedFarmers.length) {
      ErrorNotification("Please select at least one farmer")
      return
    }
    setAppointmentMode("bulk")
    setSelectedFarmer(null)
  }

  const openSingleAppointment = (farmer) => {
    setAppointmentMode("single")
    setSelectedFarmer(farmer)
  }

  return (
    <>
      <div className="w-full lg:px-10 px-2 h-full py-6 lg:py-10 space-y-6">
        <div className="w-full flex flex-col space-y-2 md:flex-row md:items-center md:justify-between">
          <div className="w-full">
            <button onClick={() => history.goBack()} className="flex flex-row items-center">
              <IoIosArrowRoundBack size={25} className="mr-2 dark:text-white" />
              <p className="text-sm font-light capitalize dark:text-white">
                Back
              </p>
            </button>

            <h2 className="text-2xl font-bold dark:text-white">
              {harvestDetail?.title || 'Harvest Request Details'}
            </h2>
            {harvestDetail?.request_id && (
              <p className="text-sm text-gray-500 dark:text-gray-400 mt-1 uppercase">
                {harvestDetail.request_id}
              </p>
            )}
          </div>
        </div>

        {isLoading && (
          <div className="w-full h-96 flex items-center justify-center">
            <Spinner />
          </div>
        )}

        {!isLoading && data && (
          <div className="w-full h-full space-y-6">
            {/* Harvest Request Details Card */}
            <div className="bg-white p-2 rounded-lg shadow-sm dark:bg-dark">
              <div className="border p-4 rounded-lg border-gray-200 dark:border-border-dark ">
                <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                  {/* Left Column */}
                  <div className="space-y-4">
                    <div className="flex flex-col">
                      <span className="text-gray-500 text-sm mb-1">Request ID:</span>
                      <span className="font-semibold text-base dark:text-white">{harvestDetail?.request_id || requestId || 'N/A'}</span>
                    </div>

                    <div className="flex flex-col">
                      <span className="text-gray-500 text-sm mb-1">Sent To:</span>
                      <span className="font-semibold text-base dark:text-white">
                        {harvestDetail?.target_groups?.length > 0
                          ? harvestDetail.target_groups.map(group => group.group_name).join(', ')
                          : 'All Farmers'
                        }
                      </span>
                    </div>

                    <div className="flex flex-col">
                      <span className="text-gray-500 text-sm mb-1">{getWeightFieldLabel(harvestDetail)}:</span>
                      <span className="font-semibold text-base dark:text-white">{formatHarvestQuantityDisplay(harvestDetail)}</span>
                    </div>
                  </div>

                  {/* Middle Column */}
                  <div className="space-y-4">
                    <div className="flex flex-col">
                      <span className="text-gray-500 text-sm mb-1">Created By:</span>
                      <span className="font-semibold text-base dark:text-white">
                        {harvestDetail?.owner ? `${harvestDetail.owner.firstname} ${harvestDetail.owner.lastname}` : 'Myself'}
                      </span>
                    </div>

                    <div className="flex flex-col">
                      <span className="text-gray-500 text-sm mb-1">Commodity:</span>
                      <span className="font-semibold text-base dark:text-white">
                        {harvestDetail?.commodity?.name || 'N/A'}
                      </span>
                    </div>

                    <div className="flex flex-col">
                      <span className="text-gray-500 text-sm mb-1">Total Responses:</span>
                      <span className="font-semibold text-base dark:text-white">
                        {harvestDetail?.response_stats?.total_responses || 0}/{harvestDetail?.target_groups?.reduce((total, group) => total + group.total_members, 0) || 0}
                      </span>
                    </div>
                  </div>

                  {/* Right Column */}
                  <div className="space-y-4">
                    <div className="flex flex-col">
                      <span className="text-gray-500 text-sm mb-1">Date Sent:</span>
                      <span className="font-semibold text-base dark:text-white">{formatDate(harvestDetail?.created_at)}</span>
                    </div>

                    <div className="flex flex-col">
                      <span className="text-gray-500 text-sm mb-1">Price Offered:</span>
                      <span className="font-semibold text-base dark:text-white">
                        {formatHarvestPriceDisplay(harvestDetail)}
                      </span>
                    </div>

                    <div className="flex flex-col">
                      <span className="text-gray-500 text-sm mb-1">Est. Total Value:</span>
                      <span className="font-semibold text-base dark:text-white">
                        {formatHarvestEstimatedValue(harvestDetail)}
                      </span>
                    </div>

                    <div className="flex flex-col">
                      <span className="text-gray-500 text-sm mb-1">Request Type:</span>
                      <span className="font-semibold text-base dark:text-white">
                        {harvestDetail?.to_all_farmer ? 'All Farmers' : 'Group Specific'}
                      </span>
                    </div>
                  </div>

                  {harvestDetail?.notes && (
                    <div className="flex flex-col mt-4 pt-4 border-t border-gray-200 dark:border-border-dark">
                      <span className="text-gray-500 text-sm mb-1">Notes:</span>
                      <span className="font-semibold text-base dark:text-white">{harvestDetail.notes}</span>
                    </div>
                  )}
                </div>
              </div>
            </div>

            {/* Responses Section */}
            <div className="space-y-2">
              <h3 className="text-xl font-bold dark:text-white">Responses</h3>

              {appointmentMode ? <div className="space-y-3">
                {appointmentMode === "single" && selectedFarmer && (
                <div className="bg-white p-2 rounded-lg shadow-sm dark:bg-dark">
                  <div className="border p-4 rounded-lg border-gray-200 dark:border-border-dark ">
                    <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                      <div className="space-y-4">
                        <div className="flex flex-col">
                          <span className="text-gray-500 text-sm mb-1">Farmer</span>
                          <div className="flex flex-col gap-2">
                            {selectedFarmer?.profile_image ? <div className="w-10 h-10 overflow-hidden">
                              <img
                                src={selectedFarmer?.profile_image}
                                className="w-full h-full flex  rounded-full" />
                            </div> : <div className="w-10 h-10 flex items-center justify-center rounded-full bg-gray-200">
                              <p className="text-sm uppercase font-bold">
                                {selectedFarmer?.firstname?.charAt(0)} {selectedFarmer?.lastname?.charAt(0)}
                              </p>
                            </div>}
                            <span className="font-semibold text-base dark:text-white capitalize">{selectedFarmer?.firstname} {selectedFarmer?.lastname || 'N/A'}</span>
                          </div>
                        </div>
                      </div>

                      <div className="space-y-4">
                        <div className="flex flex-col">
                          <span className="text-gray-500 text-sm mb-1">Email</span>
                          <span className="font-semibold text-base dark:text-white">{selectedFarmer?.email || 'N/A'}</span>
                        </div>
                      </div>

                      <div className="space-y-4">
                        <div className="flex flex-col">
                          <span className="text-gray-500 text-sm mb-1">Phone Number</span>
                          <span className="font-semibold text-base dark:text-white">{selectedFarmer?.phone || 'N/A'}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                )}
                {appointmentMode === "bulk" && (
                  <div className="bg-white p-4 rounded-lg shadow-sm dark:bg-dark border border-gray-200 dark:border-border-dark">
                    <p className="text-sm text-gray-500 dark:text-gray-400">Booking appointments for</p>
                    <p className="text-lg font-semibold dark:text-white">
                      {selectedFarmers.length} selected farmer{selectedFarmers.length !== 1 ? "s" : ""}
                    </p>
                  </div>
                )}
                <h3 className="text-xl font-bold dark:text-white">
                  Appointment Schedule
                </h3>
                <div className="bg-white p-2 rounded-lg shadow-sm dark:bg-black">
                  <div className="border p-4 rounded-lg border-gray-200 dark:border-border-dark space-y-4">

                    <div className="flex flex-col md:flex-row  gap-2">
                      <div className="flex-1">
                        <label className="block text-sm font-medium mb-1 dark:text-white">Date</label>
                        <input
                          type="date"
                          className="w-full bg-white dark:bg-secondaryDark border dark:border-border-dark dark:text-white rounded-md py-2 font-light px-3 focus:outline-none focus:ring-2 focus:ring-yellowcolor focus:border-transparent placeholder-gray-400"
                          value={selectedDate}
                          onChange={e => setSelectedDate(e.target.value)}
                        />
                      </div>

                      <div className="flex-1">
                        <div className="flex-1">
                          <label className="block text-sm font-medium mb-1 dark:text-white">Time</label>
                          <div className="relative">
                            <input
                              type="time"
                              className="w-full bg-white dark:bg-secondaryDark border dark:border-border-dark dark:text-white rounded-md py-2 font-light px-3 focus:outline-none focus:ring-2 focus:ring-yellowcolor focus:border-transparent placeholder-gray-400"
                              value={selectedTime}
                              onChange={handleTimeChange}
                            />
                          </div>
                        </div>

                      </div>
                    </div>

                    <div>
                      <label className="block text-sm font-medium mb-1 dark:text-white">Appointment Purpose</label>
                      <textarea
                        placeholder='Enter appointment purpose'
                        cols={30}
                        value={appointmentDescription}
                        onChange={(e) => setAppointmentDescription(e.target.value)}
                        rows={4}
                        className="w-full  bg-white dark:bg-secondaryDark border dark:border-border-dark dark:text-white rounded-md py-2 font-light px-3 pr-10 focus:outline-none focus:ring-2 focus:ring-yellowcolor focus:border-transparent placeholder-gray-400"
                      // {...register('description', { required: 'Description is required' })}
                      ></textarea>
                    </div>


                    <div className="flex flex-row items-end justify-end gap-4">
                      <button
                        type="button"
                        onClick={resetAppointmentForm}
                        className='px-6 text-sm py-2 bg-white dark:bg-dark border dark:border-border-dark dark:text-white text-black rounded-lg'>
                        Close
                      </button>

                      <button
                        type="button"
                        onClick={handleSubmitAppointment}
                        disabled={submitAppointment}
                        className={`px-6 text-sm py-2 bg-yellowcolor text-black rounded-lg ${submitAppointment ? "opacity-50 cursor-not-allowed" : ""}`}>
                        {submitAppointment
                          ? "Submitting..."
                          : appointmentMode === "bulk"
                            ? `Book ${selectedFarmers.length} Appointments`
                            : "Book Appointment"}
                      </button>
                    </div>
                  </div>
                </div>
              </div> :
                <div className="bg-white space-y-3 p-4 rounded-lg  border border-gray-200 dark:border-border-dark dark:bg-dark">
                  {/* Top Control Bar */}
                  <div className="flex flex-col sm:flex-row gap-4 items-start sm:items-center justify-between">
                    <div className="flex flex-col sm:flex-row gap-4 w-full sm:w-auto">
                      {/* Search Input */}
                      <div className="relative">
                        <BsSearch className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" />
                        <input
                          type="text"
                          placeholder="Search farmer"
                          className="w-full bg-white dark:bg-dark border dark:border-border-dark dark:text-white rounded-md py-2 font-light px-9 focus:outline-none focus:ring-2 focus:ring-yellowcolor focus:border-transparent placeholder-gray-400"
                        />
                      </div>

                      {/* Date Selector */}
                      <button className="flex items-center gap-2 px-4 py-2 border border-gray-300 rounded-md bg-white hover:bg-gray-50 dark:bg-dark dark:border-border-dark dark:text-white transition-colors">
                        <BsCalendar className="text-gray-400" />
                        <span className="text-gray-700 dark:text-white">Select Dates</span>
                      </button>
                    </div>

                    {selectedFarmers.length > 0 && (
                      <button
                        type="button"
                        onClick={openBulkAppointment}
                        className="bg-yellowcolor hover:bg-yellowcolor/90 text-black px-6 py-2 text-sm rounded-md font-medium transition-colors whitespace-nowrap"
                      >
                        Book Appointment ({selectedFarmers.length})
                      </button>
                    )}
                  </div>

                  {/* Responses Table */}
                  <div className="-m-1.5 overflow-x-auto">
                    <div className="p-1.5 min-w-full inline-block align-middle">
                      <div className="bg-white dark:bg-dark border dark:border-border-dark dark:text-white bg-clip-border rounded-lg shadow-sm">
                        <div className="overflow-x-auto w-full" style={{ WebkitOverflowScrolling: 'touch' }}>
                          <table className="min-w-[900px] w-full divide-y divide-gray-200 dark:divide-border-dark">
                            <thead className="bg-transparent dark:bg-secondaryDark">
                              <tr>
                                <th className="px-6 py-3 text-start text-sm font-light text-gray-500  capitalize hover:text-border-dark dark:hover:text-border-dark  ">
                                  <div className="flex items-center gap-3">
                                    <input
                                      type="checkbox"
                                      checked={bookableResponses.length > 0 && selectedFarmers.length === bookableResponses.length}
                                      onChange={handleSelectAll}
                                      disabled={bookableResponses.length === 0}
                                      className="h-4 w-4 text-yellowcolor border-gray-300 rounded focus:ring-yellowcolor dark:bg-dark dark:border-border-dark"
                                    />
                                    Farmer
                                  </div>
                                </th>
                                <th className="px-6 py-3 text-start text-sm font-light text-gray-500  capitalize hover:text-border-dark dark:hover:text-border-dark  ">
                                  Requested Quantity
                                </th>
                                <th className="px-6 py-3 text-start text-sm font-light text-gray-500  capitalize hover:text-border-dark dark:hover:text-border-dark  ">
                                  Quantity
                                </th>
                                <th className="px-6 py-3 text-start text-sm font-light text-gray-500  capitalize hover:text-border-dark dark:hover:text-border-dark  ">
                                  USSD Response
                                </th>
                                <th className="px-6 py-3 text-start text-sm font-light text-gray-500  capitalize hover:text-border-dark dark:hover:text-border-dark  ">
                                  Date Received
                                </th>
                                <th className="px-6 py-3 text-start text-sm font-light text-gray-500  capitalize hover:text-border-dark dark:hover:text-border-dark  ">
                                  Supply Response
                                </th>
                                <th className="px-6 py-3 text-start text-sm font-light text-gray-500  capitalize hover:text-border-dark dark:hover:text-border-dark  ">
                                  Action
                                </th>
                              </tr>
                            </thead>
                            <tbody className="divide-y bg-white divide-gray-200 dark:bg-dark dark:divide-border-dark">
                              {harvestDetail?.responses?.map((response) => (
                                <tr key={response?.id} className="text-[13px]">
                                  <td className="px-6 py-4 whitespace-nowrap flex items-center gap-3">
                                    <input
                                      type="checkbox"
                                      checked={selectedFarmers.includes(response?.id)}
                                      onChange={() => handleSelectFarmer(response?.id)}
                                      disabled={response?.response_type?.toLowerCase() !== "accept"}
                                      className="h-4 w-4 text-yellowcolor border-gray-300 rounded focus:ring-yellowcolor dark:bg-dark disabled:opacity-40"
                                    />
                                    <div className="flex items-center">
                                      <div className="flex-shrink-0 h-10 w-10">
                                        {response?.user_data?.profile_image ? <div className="w-10 h-10 overflow-hidden">
                                          <img
                                            src={response?.user_data?.profile_image}
                                            className="w-full h-full flex  rounded-full" />
                                        </div> : <div className="h-10 w-10 rounded-full bg-gray-300 flex items-center justify-center">
                                          <span className="text-sm font-medium text-gray-700">
                                            {getInitials(response?.responder_name)}
                                          </span>
                                        </div>
                                        }
                                      </div>
                                      <div className="ml-4">
                                        <div className="text-sm capitalize font-medium text-gray-900 dark:text-white">
                                          {response?.responder_name}
                                        </div>
                                      </div>
                                    </div>
                                  </td>
                                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900 dark:text-white">
                                    {formatHarvestQuantityDisplay(harvestDetail)}
                                  </td>
                                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900 dark:text-white">
                                    {response?.quantity || "N/A"}
                                  </td>
                                  <td className="px-6 py-4 whitespace-nowrap">
                                    <span className={`inline-flex px-2 py-1 text-xs font-semibold rounded-full capitalize ${getUssdResponseColor(response?.response_type)} dark:text-black text-xs`}>
                                      {response?.response_type}
                                    </span>
                                  </td>
                                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900 dark:text-white">
                                    {formatDate(response?.created_at)}
                                  </td>
                                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900 dark:text-white">
                                    <span className={`inline-flex px-2 py-1 text-xs font-semibold rounded-full ${getUssdResponseColor(response?.response_type)} dark:text-black text-xs capitalize`}>
                                      {response?.response_type}
                                    </span>
                                  </td>
                                  <td className="px-6 py-4 whitespace-nowrap">
                                    {response?.response_type?.toLowerCase() === "accept" ? (
                                      <button
                                        type="button"
                                        onClick={() => openSingleAppointment(response?.user_data)}
                                        className="bg-yellowcolor hover:bg-yellowcolor/90 text-black px-3 py-2 text-sm rounded-md font-medium transition-colors">
                                        Book Appointment
                                      </button>
                                    ) : response?.response_type?.toLowerCase() === "rejected" ? (
                                      <button
                                        type="button"
                                        className="border border-gray-400 dark:border-border-dark dark:text-white text-gray-700 px-3 py-2 rounded-md font-medium text-sm transition-colors">
                                        Send New Request
                                      </button>
                                    ) : null}
                                  </td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        </div>
                        {/* Pagination */}
                        {data?.responses?.length > 0 && <div className="bg-white border-t border-gray-200 p-3 flex flex-row items-center justify-between w-full dark:bg-dark dark:border-border-dark">

                          <button
                            // onClick={handlePrev}
                            // disabled={currentPage === 1}
                            className="px-4 py-1.5 flex flex-row items-center gap-2 bg-gray-100 hover:bg-gray-200 border-md text-black border rounded-lg font-light text-sm border-gray-300 disabled:opacity-50 disabled:cursor-not-allowed dark:bg-secondaryDark dark:border-border-dark dark:text-white">
                            <IoArrowBack size={16} />
                            Previous
                          </button>

                          <div className="flex items-center gap-2">
                            <span className="text-sm text-gray-700 dark:text-white">
                              Page 1 of 10
                            </span>
                            <span className="text-sm text-gray-700 dark:text-white">
                              Showing 1 to 10 of 10 entries
                            </span>
                          </div>

                          <button
                            // onClick={handleNext}
                            // disabled={currentPage === totalPages}
                            className="px-4 py-1.5 flex flex-row items-center gap-2 bg-gray-100 hover:bg-gray-200 border-md text-black border rounded-lg font-light text-sm border-gray-300 disabled:opacity-50 disabled:cursor-not-allowed dark:bg-secondaryDark dark:border-border-dark dark:text-white">
                            Next
                            <IoArrowForward size={16} />
                          </button>
                        </div>}
                      </div>
                    </div>
                  </div>

                </div>}
            </div>
          </div>
        )}

        {!isLoading && !data && (
          <div className="w-full h-96 flex items-center justify-center">
            <div className="text-center">
              <p className="text-gray-500 dark:text-gray-400">No data available</p>
            </div>
          </div>
        )}
      </div>
    </>
  )
}

export default HarvestDetailView
